import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFound = () => {
  return (
    <div className="bg-white py-16">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-[#16A34A] mb-4">404</h1>
          <h2 className="text-3xl font-bold text-[#0F172A] mb-4">Seite nicht gefunden</h2>
          <p className="text-lg text-gray-700 mb-8">
            Die von Ihnen gesuchte Seite existiert leider nicht. Möglicherweise wurde sie verschoben 
            oder die URL ist nicht korrekt.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Button asChild size="lg" className="bg-[#16A34A] hover:bg-[#16A34A]/90 text-white">
            <Link to="/" className="flex items-center gap-2">
              <Home className="h-5 w-5" />
              Zur Startseite
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="border-[#16A34A] text-[#16A34A] hover:bg-[#16A34A] hover:text-white">
            <Link to="/kontakt" className="flex items-center gap-2">
              <Search className="h-5 w-5" />
              Kontakt
            </Link>
          </Button>
        </div>

        <div className="bg-gray-50 rounded-lg p-8">
          <h3 className="text-xl font-semibold text-[#0F172A] mb-4">Beliebte Seiten:</h3>
          <ul className="space-y-2">
            <li>
              <Link to="/leistungen" className="text-[#16A34A] hover:underline">
                Unsere Leistungen in Dortmund
              </Link>
            </li>
            <li>
              <Link to="/preise" className="text-[#16A34A] hover:underline">
                Preise & Ablauf
              </Link>
            </li>
            <li>
              <Link to="/faq" className="text-[#16A34A] hover:underline">
                Häufig gestellte Fragen (FAQ)
              </Link>
            </li>
            <li>
              <Link to="/kontakt" className="text-[#16A34A] hover:underline">
                Kontakt & Angebot anfordern
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFound;